import React, { useEffect } from 'react'
import { Button, AppBar, Toolbar, FormControl, Select, Input, MenuItem, Checkbox, ListItemText, InputBase, Typography } from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search'
import { withRouter, Link } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'
import { fade } from '@material-ui/core/styles/colorManipulator'
import { useTranslation } from 'react-i18next'

import UnauthorizedContols from './unauthorized-controls/UnauthorizedContols'
import AuthorizedControls from './authorized-controls/AuthorizedControlsContainer'

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: 300
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  chip: {
    margin: theme.spacing.unit / 4
  },
  noLabel: {
    marginTop: theme.spacing.unit * 3
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25)
    },
    marginRight: theme.spacing.unit * 2,
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing.unit * 3,
      width: 'auto'
    }
  },
  searchIcon: {
    width: theme.spacing.unit * 9,
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  inputRoot: {
    color: 'inherit',
    width: '100%'
  },
  inputInput: {
    paddingTop: theme.spacing.unit,
    paddingRight: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    paddingLeft: theme.spacing.unit * 10,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: 300
    }
  },
  grow: {
    flexGrow: 1
  },
  authButtons: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit
  },
  navLink: {
    textDecoration: 'none',
    color: 'black'
  }
})

const ITEM_HEIGHT = 100
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
}

// creates the value for "select" based on selected categories
const combineCategoriesValue = (categories) => {
  const value = []
  for (let i = 0, l = categories.length; i < l; i += 1) {
    if (categories[i].isSelected) {
      value.push(categories[i].name)
    }
  }
  return value
}

// Component for the topmost panel with filtering, searching and authentication
const TopPanel = ({ classes, categories, email, fetchCategories, onCategoryChecked, onSearchTextChanged, location }) => {
  const { t, i18n } = useTranslation()
  useEffect(() => { fetchCategories(i18n.language) }, [ i18n.language ]) // fetch categories with the current locale
  const { pathname } = location
  return <div className='root'>
    <AppBar position='fixed'>
      <Toolbar>
        <FormControl className='formControl'>
          <Select
            multiple
            value={combineCategoriesValue(categories)}
            input={<Input id="select-multiple-checkbox" />}
            renderValue={() => t('TopBar:categories')}
            displayEmpty={true}
            MenuProps={MenuProps}
          >
            {/* filling categories popup with the values received from server */}
            {categories.map(category => (
              <MenuItem key={category.id} value={category.name}>
                <Checkbox checked={category.isSelected}
                  onChange={() => onCategoryChecked(category.id)} />
                <ListItemText primary={category.name} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <div className={classes.search}>
          <div className={classes.searchIcon}>
            <SearchIcon />
          </div>
          <InputBase
            placeholder={t('TopBar:search')}
            classes={{
              root: classes.inputRoot,
              input: classes.inputInput
            }}
            onChange={event => onSearchTextChanged(event.target.value)}
          />
        </div>
        <Typography className={classes.grow} />
        { email
          ? (<AuthorizedControls />)
          : (
            <>
              {
                (pathname !== '/') ? (
                  <Button className={classes.authButtons} variant='contained'>
                    <Link to='/' className={classes.navLink}>
                      {t('TopBar:main page')}
                    </Link>
                  </Button>
                ) : null
              }
              <UnauthorizedContols />
            </>
          )
        }
      </Toolbar>
    </AppBar>
  </div>
}

export default withRouter(withStyles(styles)(TopPanel))
